var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isZero)?_c('span',[_vm._v("-")]):_c('v-progress-linear',{staticClass:"rounded rounded-l-0",attrs:{"value":_vm.value,"height":_vm.height,"color":_vm.$options.filters.thermo((100 - _vm.value) / 100)},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var value = ref.value;
return [_c('span',{staticClass:"text-caption white--text"},[_vm._v(_vm._s(Math.ceil(value * 100) / 100)+"%")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }